import Certificates from "./Certificates";
import Footer from "./Footer";
import Hero from "./Hero";
import Myprojects from "./Myprojects";
import Skills from "./Skills";
import { motion } from "framer-motion";
import ContactMe from "./ContactMe";
import Testmonials from "./Testmonials";
import { useEffect, useState } from "react";
import React from 'react'
import useMouse from "@react-hook/mouse-position";



const Home = () => {

  


  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [cursorVariant, setCursorVariant] = useState('default');
  const [message, setMessage] = useState('default');

  
  const handleMouseMove = (e) => {
    setPosition({ x: e.clientX + window.scrollX, y: e.clientY + window.scrollY });
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);


    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [position]);
  
 

  const variants = {
    default: {
      x: position.x+70,
      y: position.y ,
      zIndex: -1,
      background:"transparent"
    },
    live: {
      width: 100,
      height: 50,
      zIndex: 100,
      x: position.x+37,
      y: position.y - 73,
      cursor: "none",
      background: "var(--blue-color)",
      borderRadius:"50%"

    },
    liveGit: {
      width: 100,
      height: 50,
      zIndex: 100,
      x: position.x-137,
      y: position.y - 73,
      cursor: "none",
      background: "var(--blue-color)",
      borderRadius:"50%"

    },
    contactMe: {
      width: 200,
      height: 50,
      zIndex: 100,
      x: position.x+137,
      y: position.y - 73,
      cursor: "none",
    }
  }
    
  


  return (
    <motion.div className="home" exit={{ x: '-100vw' }} transition={{ ease: 'easeInOut' }} initial={{ x: '100vw' }} animate={{ x: 0 }}>
      <motion.div  ></motion.div>
      <Hero />
      <Skills  />
      <Myprojects />
      {/* <Testmonials setCursorVariant={setCursorVariant}/> */}
      <Certificates />
      <ContactMe/>
      <Footer />
      
      
    </motion.div>
  );
};

export default Home;
